import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output
} from '@angular/core';
import { OperatorFindInterface } from '@zaoblako/shared/modules/finance/dtos/operator/operator-find.dto';
import { GlobalService } from '@zaoblako/web/core/services/global.service';
import { OperatorService } from '@zaoblako/web/core/services/ofd/operator.service';
import { SingleSelectComponent } from '@zaoblako/web/shared/dumbs/dropdowns/single-select/single-select.component';

@Component({
  selector: 'crm-operator-single-select',
  standalone: true,
  imports: [CommonModule, SingleSelectComponent],
  templateUrl: './operator-single-select.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class OperatorSingleSelectComponent implements OnInit {
  @Input() public operators: OperatorFindInterface[] = [];

  @Input() public selectedOperator: OperatorFindInterface;
  @Output() public selectedOperatorChange = new EventEmitter<OperatorFindInterface>();

  @Input() public customRequest = false;
  @Input() public showClear = true;
  @Input() public disabled = false;
  @Input() public isError = false;
  @Input() public class: string;
  @Input() public styleClass: string;
  @Input() public appendTo: string;

  public constructor(
    private readonly globalService: GlobalService,
    private readonly operatorService: OperatorService,
    private readonly cdRef: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    if (
      !this.customRequest &&
      this.globalService.globalInfo.tenantInfo?.ratePlan?.modulesAccessControl?.BASIS?.enabled
    ) {
      this.operatorService.findFlat().subscribe({
        next: (operators) => {
          this.operators = operators;
          this.cdRef.markForCheck();
        }
      });
    }
  }
}
